module.exports = __webpack_public_path__ + "img/Pop-up_03_1.a86358f0.png";